<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <input
      v-model="value"
      :class="errorMessage ? 'is-invalid' : ''"
      autocomplete="new-password" class="form-control"
      :placeholder="placeholder"
      type="password"
    >
    <div class="invalid-feedback">{{ errorMessage }}</div>
    <span class="form-text">英数字,記号(!#$%()*+,.:;=?@[]^_{}-)を使用し、12文字以上で作成してください。</span>
  </form-layout>
</template>
<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem';
import FormLayout from "@/views/templates/FormLayout";

export default {
  name: "VuexPasswordFormItem",
  extends: BaseVuexFormItem,
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  components: {
    FormLayout
  },
}
</script>
